/* eslint-disable no-unused-expressions */
<template>
  <div style="width=100% !important; min-width:100% !important">
    <div>
      <!--style="opacity: 0;"-->
      <!-- style="position:relative; z-index: -9999;" -->
      <div id="printable">
        <div class="row mt-15">
          <div class="col-md-12 pl-10">
            <div id="table">
              <div class="container">
                <table class="table table-borderless" cellpadding="-1">
                  <tbody>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Balance Sheet</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Current Assets</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Cash and cash equivalents</td>
                      <td>{{ Number(outputData.current.balanceSheet.cashAndCashEquivalents).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.cashAndCashEquivalents).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Short-term investments</td>
                      <td>{{ Number(outputData.current.balanceSheet.shortTermInvestments).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.shortTermInvestments).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Accounts receivable</td>
                      <td>{{ Number(outputData.current.balanceSheet.accountsReceiveable).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.accountsReceiveable).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Inventory</td>
                      <td>{{ Number(outputData.current.balanceSheet.inventory).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.inventory).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other Current Assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.otherCurrentAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.otherCurrentAssets).toLocaleString() }}</td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td style="font-style: bold;">Total Current Assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalCurrentAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalCurrentAssets).toLocaleString() }}</td>
                    </tr>
                    <tr class="border-bottom-0">
                      <td colspan="3"></td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold">Long-Term Assets</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Fixed assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.fixedAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.fixedAssets).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Intangible Assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.intangibles).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.intangibles).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Long-term financial investments</td>
                      <td>{{ Number(outputData.current.balanceSheet.longTermFinancialInvestments).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.longTermFinancialInvestments).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Deferred taxes</td>
                      <td>{{ Number(outputData.current.balanceSheet.deferredTaxes).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.deferredTaxes).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other long-term assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.otherLongTermAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.otherLongTermAssets).toLocaleString() }}</td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td>Total long-term assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalLongTermAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalLongTermAssets).toLocaleString() }}</td>
                    </tr>
                    <tr class="border-bottom-0">
                      <td colspan="3"></td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td>Total Assets</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalAssets).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalAssets).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Current Liabilities</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Borrowings</td>
                      <td>{{ Number(outputData.current.balanceSheet.borrowings).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.borrowings).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Accounts payable</td>
                      <td>{{ Number(outputData.current.balanceSheet.accountsPayable).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.accountsPayable).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other current liabilities</td>
                      <td>{{ Number(outputData.current.balanceSheet.otherCurrentLiabilities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.otherCurrentLiabilities).toLocaleString() }}</td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td>Total current liabilities</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalCurrentLiabilities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalCurrentLiabilities).toLocaleString() }}</td>
                    </tr>
                    <tr class="border-bottom-0">
                      <td colspan="3"></td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Long-Term Liabilities</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Long-term debt</td>
                      <td>{{ Number(outputData.current.balanceSheet.longTermDebt).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.longTermDebt).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Deferred income taxes</td>
                      <td>{{ Number(outputData.current.balanceSheet.deferredIncomeTaxes).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.deferredIncomeTaxes).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Provisions</td>
                      <td>{{ Number(outputData.current.balanceSheet.provisions).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.provisions).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other long-term liabilities</td>
                      <td>{{ Number(outputData.current.balanceSheet.otherLongTermLiabilities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.otherLongTermLiabilities).toLocaleString() }}</td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td>Total long-term liabilities</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalLongTermLiabilities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalLongTermLiabilities).toLocaleString() }}</td>
                    </tr>
                    <tr class="border-bottom-0">
                      <td colspan="3"></td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td>Total Liabilities</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalLiabilities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalLiabilities).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td style="font-style: bold">
                        <span>Shareholder's Equity</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Authorized capital</td>
                      <td>{{ Number(outputData.current.balanceSheet.authorizedCapital).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.authorizedCapital).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Additional paid-in capital</td>
                      <td>{{ Number(outputData.current.balanceSheet.additionalPaidInCapital).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.additionalPaidInCapital).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Retained earnings</td>
                      <td>{{ Number(outputData.current.balanceSheet.retainedEarnings).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.retainedEarnings).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other</td>
                      <td>{{ Number(outputData.current.balanceSheet.other).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.other).toLocaleString() }}</td>
                    </tr>
                    <tr class="table-sub-heading border-bottom-0">
                      <td style="font-style:bold;">Total shareholder's equity</td>
                      <td>{{ Number(outputData.current.balanceSheet.totalShareholdersEquity).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.balanceSheet.totalShareholdersEquity).toLocaleString() }}</td>
                    </tr>
                    <tr class="border-bottom-0">
                      <td colspan="3"></td>
                    </tr>
                    <tr class="table-sub-heading">
                      <td style="font-style: bold;">Total Liabilities and Shareholders' Equity</td>
                      <td
                        class="border-top-0"
                      >{{ Number(outputData.current.balanceSheet.totalLiabilitiesAndShareholdersEquity).toLocaleString() }}</td>
                      <td

                        class="border-top-0"
                      >{{ Number(outputData.previous.balanceSheet.totalLiabilitiesAndShareholdersEquity).toLocaleString() }}</td>
                    </tr>
                    <tr class="page-break mt-15">
                      <td>
                        <b style="font-style: bold;">Income Statement</b>
                      </td>
                    </tr>
                    <tr class="secondLastChild">
                      <td style="font-style: bold;">Revenue</td>
                      <td
                        style="font-style: bold"
                      >{{ Number(outputData.current.incomeStatement.revenue).toLocaleString() }}</td>
                      <td
                        style="font-style: bold;"
                      >{{ Number(outputData.previous.incomeStatement.revenue).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Cost of goods sold</td>
                      <td>{{Number(outputData.current.incomeStatement.costOfGoodsSold).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.costOfGoodsSold).toLocaleString() }}</td>
                    </tr>
                    <tr class="secondLastChild">
                      <td>Gross profit (loss)</td>
                      <td
                        style="font-style: bold"
                      >{{ Number(outputData.current.incomeStatement.grossProfitLoss).toLocaleString() }}</td>
                      <td
                        style="font-style: bold;"
                      >{{ Number(outputData.previous.incomeStatement.grossProfitLoss).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Operating expenses</td>
                      <td>{{ Number(outputData.current.incomeStatement.operatingExpenses).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.operatingExpenses).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Operating profit (loss)</td>
                      <td>{{ Number(outputData.current.incomeStatement.operatingProfitLoss).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.operatingProfitLoss).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Income from investments in other enterprises</td>
                      <td>{{ Number(outputData.current.incomeStatement.incomeFromInvestmentsInOtherEnterprises).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.incomeFromInvestmentsInOtherEnterprises).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Interest receivable</td>
                      <td>{{ Number(outputData.current.incomeStatement.interestReceivable).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.interestReceivable).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Interest expense</td>
                      <td>{{ Number(outputData.current.incomeStatement.interestExpense).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.interestExpense).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Other expenses</td>
                      <td>{{ Number(outputData.current.incomeStatement.otherExpenses).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.otherExpenses).toLocaleString() }}</td>
                    </tr>
                    <tr class="secondLastChild">
                      <td>Earnings before income tax</td>
                      <td>{{ Number(outputData.current.incomeStatement.earningsBeforeIncomeTax).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.earningsBeforeIncomeTax).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Income taxes</td>
                      <td>{{ Number(outputData.current.incomeStatement.incomeTax).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.incomeTax).toLocaleString() }}</td>
                    </tr>
                    <tr class="secondLastChild">
                      <td>Net income</td>
                      <td>{{ Number(outputData.current.incomeStatement.netIncome).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.incomeStatement.netIncome).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Cash Flow Statement</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Net cash provided by (used in) operating activities</td>
                      <td>{{ Number(outputData.current.cashFlowStatement.operatingActivities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.cashFlowStatement.operatingActivities).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Net cash provided by (used in) investing activities</td>
                      <td>{{ Number(outputData.current.cashFlowStatement.investingActivities).toLocaleString() }}</td>
                      <td

                      >{{ Number(outputData.previous.cashFlowStatement.investingActivities).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Net cash provided by (used in) financing activities</td>
                      <td
                        class="noBold"
                      >{{ Number(outputData.current.cashFlowStatement.financingActivities).toLocaleString() }}</td>
                      <td

                        class="noBold"
                      >{{ Number(outputData.previous.cashFlowStatement.financingActivities).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b style="font-style: bold;">Supplementary Information</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Depreciation and Amortization</td>
                      <td
                        class="noBold"
                      >{{ Number(outputData.current.supplementaryInformation.depreciationAndAmortization).toLocaleString() }}</td>
                      <td

                        class="noBold"
                      >{{ Number(outputData.previous.supplementaryInformation.depreciationAndAmortization).toLocaleString() }}</td>
                    </tr>
                    <tr>
                      <td>Capital Expenditures</td>
                      <td
                        class="noBold"
                      >{{ Number(outputData.current.supplementaryInformation.capitalExpenditures).toLocaleString() }}</td>
                      <td

                        class="noBold"
                      >{{ Number(outputData.previous.supplementaryInformation.capitalExpenditures).toLocaleString() }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <p
          class="pl-10 blue-text font-16"
        >The financial statements translation provided by us is based on information provided and entered by the user which is believed to be accurate and reliable. We cannot independently verify or validate information entered by the user. Because of the possibility of human, technical or mechanical error, all information is presented "as is" without any warranty of any kind. No warranty, express or implied, as to the accuracy, timeliness or completeness is given or made by us, directly or indirectly, in any form or manner whatsoever. To the extent permitted by law, our employees and officers disclaim liability to any person or entity for any direct, indirect, special, consequential, incidental or compensatory losses, loss of present or future revenue or profits, or any damages whatsoever arising from or in connection with the use, or inability to use, the information contained in the financial statement translations. To the extent permitted by law, our employees and officers disclaim liability to any person or entity for any damages caused by negligence on our part or any contingency within or out of control of our employees and officers.</p>
      </div>
      <div class="page-template row">
        <div>
          <div id="intro-left" class="header mb-10">
            <div class="row">
              <div class="col-md-9 intro">
                <b style="font-size: 30px; font-style: bold;">{{intro.companyTitle}}</b>
                <br />
                <b>{{intro.currency}}</b>
                <br />
                <b>{{intro.denomination}}</b>
              </div>
              <div class="col-md-3 pdf-logo sticky-top">
                <div id="logo">
                  <img :src="logoData.src" :alt="logoData.altText" style="float: right;" />
                </div>
              </div>
            </div>
            <table
              class="table table-borderless"
              style="margin-left:8%; font-weight:bold;"
              cellpadding="-1"
            >
              <tbody>
                <tr>
                  <td style="padding-left: 25%;width:395px;"></td>
                  <td style="padding-left: 0%;text-align:right;">
                    <b style="font-style: bold;">
                      {{headerData.currentYear}}
                    </b>
                  </td>
                  <td class="table-header-data" style="padding-right: 247px;text-align:right;">
                    <b style="font-style:bold;">
                      # if ( pageNum == 1) { #
                        {{firstPageTitle}}
                      # } #
                      # if ( pageNum != 1) { #
                        {{headerData.previousYear}}
                      # } #
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="footer">
            <div class="leftdate">{{this.dates}}</div>
            <div class="disclaimer">
              This translation was prepared exclusively for {{this.userName}}.
              Not for distribution unless permitted in writing by fintransformer.com.
              <!-- This was prepared exclusively for {{this.userName}}
              <br />Not for distribution unless permitted.-->
            </div>
            <div class="pagenum">
              <h4>Page #:pageNum#</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// const momment = require('vue-moment')
export default {
  name: "generatePDF",
  // Data to be printed from calling component will be placed here
  props: [
    "intro",
    "title",
    "logoData",
    "outputData",
    "headerData",
    "exportToExcel",
    "user",
    "firstPageTitle"
  ],
  data() {
    return {
      dates: this.$moment().format("YYYY-MM-DD"),
      userName: this.user.name,
      balanceSheetHeaders: true,
      hide: false,
      exportToExcelExec: this.exportToExcel
    };
  },
  mounted() {
    // console.log("firstPageTitle", this.firstPageTitle);
    // console.log("headerData", this.headerData);
    this.initializePrinter();
  },
  methods: {
    // print method
    initializePrinter() {
      // console.log('I am never Old Bro !!!')
      if (this.exportToExcelExec == true) {
        this.initGenerateExcel();
      } else {
        this.printWithKendo();
      }
    },
    printWithKendo() {
      var self = this;
      kendo.drawing
        .drawDOM("#printable", {
          multiPage: true,
          forcePageBreak: ".page-break",
          // margin: { left: "1cm", top: "1cm", right: "3cm", bottom: "2cm" },
          paperSize: "A4",
          scale: 0.5,
          height: 500,
          template: kendo.template($(".page-template").html())
        })
        .then(function(group) {
          // console.log("group", group);
          kendo.drawing.pdf.saveAs(group, "FinancialStatment.pdf");
        })
        .then(function() {
          self.$emit("hidePrinter", this.hide);
        });
    },
    initGenerateExcel() {
      var self = this;
      return this.printToExcel()
        .then(function() {
          self.exportToExcel = false;
        })
        .then(function() {
          self.$emit("hidePrinter", self.hide);
        });
    },
    printToExcel() {
      // var table2excel = new Table2Excel();
      // return new Promise((resolve, reject) => {
      //   resolve(
      //     table2excel.export(
      //       document.querySelectorAll("table"),
      //       "FinancialStatment"
      //     )
      //   );
      // });
      return new Promise((resolve, reject) => {
      var rows = [{
        cells: [
          { value: this.intro.companyTitle },
          { value: " " },
          { value: " " }
        ]
      }];
      rows.push({
          cells: [
            { value: this.intro.currency },
            { value: " " },
            { value: " " }
          ]
        });
      rows.push({
          cells: [
            { value: this.intro.denomination },
            { value: " " },
            { value: " " }
          ]
        });
      for(let i=0; i<2; i++){
        rows.push({
          cells: [
            { value: " " },
            { value: " " },
            { value: " " }
          ]
        });
      }
      rows.push({
        cells: [
          { value: " " },
          { value: this.headerData.currentYear },
          { value: this.headerData.previousYear }
        ]
      });
      Object.keys(this.outputData.current.balanceSheet).forEach(key => {
        // Push single row for every record.
        rows.push({
          cells: [
            { value: key.replace(/([a-z])([A-Z])/g, "$1 $2")},
            { value: this.outputData.current.balanceSheet[key].toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")},
            { value: this.outputData.previous.balanceSheet[key].toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") }
          ]
        })
        // console.log('element', element)
      });
      var workbook = new kendo.ooxml.Workbook({
        sheets: [
          {
            // The column settings (width).
            columns: [{ autoWidth: true }, { autoWidth: true }, { autoWidth: true }],
            // Th title of the sheet.
            title: "Financial Statment",
            // The rows of the sheet.
            rows: rows
          }
        ]
      });
      resolve(
      kendo.saveAs({
        dataURI: workbook.toDataURL(),
        fileName: "FinancialStatment.xlsx"
      })
      );
      });
    }
  }
};
</script>

<style scoped>
#printable {
  /* background-color: white;
  font-size: 20px;
  font-family: "Times New Roman", Times, serif; */
  font-family: "DejaVu Sans", "Arial", sans-serif;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
img {
  float: right;
}

th {
  text-align: right;
}
tr {
  margin-top: -5px;
  margin-bottom: -5px;
}
td {
  text-align: right;
  padding: 0.1rem;
  line-height: 1.2;
  font-size: 20px;
}
tr th:first-child,
tr td:first-child {
  text-align: left;
}
/* tbody tr td:first-child {
  width: 300px;
  background-color: aquamarine;
}
tbody tr:first-child td:first-child {
  width: auto;
  background-color: aquamarine;
} */
.intro {
  padding-top: 5%;
  padding-left: 10%;
  width: 100%;
  height: 100%;
}
.pdf-logo {
  padding-top: 5%;
  padding-right: 100px;
}

#print {
  padding-left: 5%;
  padding-right: 5%;
}
.title {
  /* text-align: center; */
  font-style: bold;
}
#table {
  padding: 0.1rem;
  /* padding-left: 3%; */
  padding-right: 15%;
  padding-top: 2%;
  padding-bottom: 2%;
}
table {
  padding: 0.1rem;
}
.leftdate {
  float: left;
  padding-top: 70px;
  /* margin-bottom: 10px; */
}
.disclaimer {
  text-align: center;
  color: #006ac3;
  padding-top: 26px;
  /* margin-bottom: 5px; */
}
.pagenum {
  float: right;
  /* margin-bottom: 30px; */
}
.footer {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
  border-top: 1px solid #888;
  text-align: center;
  color: #888;
}
.header {
  height: 100%;
  line-height: 20px;
}
.mb-10 {
  margin-bottom: 10%;
}
.mt-15 {
  margin-top: 15%;
}
.table > tbody > tr > td,
.table > tbody > tr > th {
  border-top: transparent;
  /* text-align: left; */
  line-height: 18px;
  /* line-height: 1; */
}
/* .table > tbody > tr > td {
  text-align: right;
} */
.pl-10 {
  padding-left: 10%;
}
.font-16 {
  font-size: 16px;
}
.blue-text {
  color: #006ac3;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/generatePDF.vue